import { EpUtil } from '../../util/ep-util';
import { BreadPluginConfig } from '../../models/plugin.model';

export class BreadLoader{
  static load(config: BreadPluginConfig){
    const dataset = {
      apiKey: config.apiKey,
    };
    EpUtil.injectScriptTag(config.scriptSrc, dataset, `bread-${config.apiKey}`);
  }
}